import { customAlphabet } from "nanoid";

export const nanoID = (prefix = "", length = 22) => {
	const nanoID = customAlphabet(
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
		length,
	);
	return `${prefix}_${nanoID()}`;
};
